import { render, staticRenderFns } from "./CreativeSimpleTable.vue?vue&type=template&id=39f396f1&scoped=true&"
import script from "./CreativeSimpleTable.vue?vue&type=script&lang=ts&"
export * from "./CreativeSimpleTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f396f1",
  null
  
)

export default component.exports